import styled from 'styled-components';

import { IconBgButton } from '@/shared/components/ui/button/icon-bg-button/icon-bg-button';

export const StyledIconBgButton = styled(IconBgButton)`
  && {
    height: 3.25rem;
    width: 3.25rem;
  }
`;
